import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: () => import('./public/home/home.module').then(m => m.HomeModule),
    // canLoad: [CheckTutorial]
  },
  {
    path: 'cgu',
    loadChildren: () => import('./public/cgu/cgu.module').then(m => m.CguModule),
    // canLoad: [CheckTutorial]
  },
  {
    path: 'connexion',
    loadChildren: () => import('./public/connexion/connexion.module').then(m => m.ConnexionModule),
    // canLoad: [CheckTutorial]
  },
  { 
    path: 'members', 
    // canActivate: [AuthGuardService],
    loadChildren: () => import('./members/member-routing.module').then(m => m.MemberRoutingModule),
  },
  // {
  //   path: '',
  //   loadChildren: () => import('./layout/layout.module').then(m => m.LayoutPageModule)
  // },
  // {
  //   path: 'app',
  //   loadChildren: () =>
  //     import('./index/index.module').then(m => m.IndexPageModule)
  // }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
